import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum LinkIconVariant {
  DEFAULT = 'default',
  SIDE_MENU = 'side_menu',
  SHARE = 'share',
}

export interface ILinkIconProps extends IConDefaultType {
  variant?: LinkIconVariant;
}

function LinkIcon({ color, className, size = 24, rotate, flip, variant = LinkIconVariant.DEFAULT }: ILinkIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === LinkIconVariant.DEFAULT && (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.95569 7.40949C6.32882 7.75916 6.34784 8.34512 5.99816 8.71826L4.60447 10.2054C4.59907 10.2112 4.59359 10.2169 4.58805 10.2225C3.90144 10.9186 3.51787 11.8533 3.51787 12.8255C3.51787 13.7947 3.89902 14.7265 4.58155 15.4219C5.28161 16.1004 6.22208 16.4813 7.20263 16.4813C8.18528 16.4813 9.12769 16.0988 9.82822 15.4175L11.2757 13.9884C11.6396 13.6292 12.2258 13.6329 12.5851 13.9968C12.9444 14.3607 12.9407 14.947 12.5768 15.3062L11.1225 16.7421C10.0748 17.7626 8.66732 18.3332 7.20263 18.3332C5.73793 18.3332 4.33051 17.7626 3.28278 16.742L3.26965 16.729C2.24241 15.6876 1.66602 14.2862 1.66602 12.8255C1.66602 11.3689 2.23917 9.97139 3.26096 8.9309L4.64692 7.45196C4.9966 7.07883 5.58255 7.05981 5.95569 7.40949Z"
            fill={color || '#303037'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.3862 6.5212C13.7478 6.88279 13.7478 7.46906 13.3862 7.83066L7.83066 13.3862C7.46906 13.7478 6.88279 13.7478 6.5212 13.3862C6.1596 13.0246 6.1596 12.4384 6.5212 12.0768L12.0768 6.5212C12.4384 6.1596 13.0246 6.1596 13.3862 6.5212Z"
            fill={color || '#303037'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.1714 4.58216L8.72392 6.01126C8.36002 6.37054 7.77377 6.3668 7.41449 6.0029C7.05521 5.639 7.05895 5.05275 7.42285 4.69347L8.87713 3.25765C9.92485 2.23712 11.3323 1.6665 12.797 1.6665C14.2617 1.6665 15.6691 2.23713 16.7168 3.25766L16.73 3.27072C17.7572 4.31212 18.3336 5.71346 18.3336 7.17417C18.3336 8.63075 17.7604 10.0283 16.7387 11.0688L15.3527 12.5477C15.003 12.9209 14.4171 12.9399 14.0439 12.5902C13.6708 12.2405 13.6518 11.6546 14.0014 11.2814L15.3951 9.79425C15.4005 9.78849 15.406 9.7828 15.4116 9.77717C16.0982 9.08109 16.4817 8.14644 16.4817 7.17417C16.4817 6.20497 16.1006 5.27316 15.4181 4.57777C14.718 3.89925 13.7775 3.51836 12.797 3.51836C11.8143 3.51836 10.8719 3.90089 10.1714 4.58216Z"
            fill={color || '#303037'}
          />
        </svg>
      )}
      {variant === LinkIconVariant.SIDE_MENU && (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 7C4.73478 7 4.48043 7.10536 4.29289 7.29289C4.10536 7.48043 4 7.73478 4 8V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H16C16.2652 20 16.5196 19.8946 16.7071 19.7071C16.8946 19.5196 17 19.2652 17 19V13C17 12.4477 17.4477 12 18 12C18.5523 12 19 12.4477 19 13V19C19 19.7957 18.6839 20.5587 18.1213 21.1213C17.5587 21.6839 16.7957 22 16 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V8C2 7.20435 2.31607 6.44129 2.87868 5.87868C3.44129 5.31607 4.20435 5 5 5H11C11.5523 5 12 5.44772 12 6C12 6.55228 11.5523 7 11 7H5Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 4C13 3.44772 13.4477 3 14 3H20C20.5523 3 21 3.44772 21 4V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V5H14C13.4477 5 13 4.55228 13 4Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.7071 3.29289C21.0976 3.68342 21.0976 4.31658 20.7071 4.70711L9.70711 15.7071C9.31658 16.0976 8.68342 16.0976 8.29289 15.7071C7.90237 15.3166 7.90237 14.6834 8.29289 14.2929L19.2929 3.29289C19.6834 2.90237 20.3166 2.90237 20.7071 3.29289Z"
            fill={color}
          />
        </svg>
      )}
      {variant === LinkIconVariant.SHARE && (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.14663 7.39168C5.59439 7.81129 5.61721 8.51444 5.1976 8.9622L3.52517 10.7468C3.51869 10.7537 3.51212 10.7606 3.50546 10.7673C2.68153 11.6026 2.22125 12.7242 2.22125 13.8909C2.22125 15.054 2.67863 16.1721 3.49767 17.0066C4.33774 17.8208 5.4663 18.2779 6.64296 18.2779C7.82215 18.2779 8.95304 17.8189 9.79367 17.0013L11.5306 15.2864C11.9673 14.8553 12.6708 14.8598 13.1019 15.2965C13.5331 15.7331 13.5286 16.4366 13.0919 16.8678L11.3468 18.5908C10.0895 19.8154 8.40059 20.5001 6.64296 20.5001C4.88532 20.5001 3.19641 19.8154 1.93914 18.5907L1.92338 18.5751C0.690701 17.3254 -0.000976562 15.6438 -0.000976562 13.8909C-0.000976562 12.143 0.686803 10.466 1.91296 9.21737L3.57611 7.44265C3.99572 6.99488 4.69887 6.97207 5.14663 7.39168Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.0635 6.32544C14.4974 6.75935 14.4974 7.46287 14.0635 7.89679L7.39679 14.5635C6.96287 14.9974 6.25935 14.9974 5.82544 14.5635C5.39152 14.1295 5.39152 13.426 5.82544 12.9921L12.4921 6.32544C12.926 5.89152 13.6295 5.89152 14.0635 6.32544Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2059 3.99878L8.4689 5.71371C8.03223 6.14484 7.32872 6.14035 6.89759 5.70367C6.46645 5.267 6.47094 4.56349 6.90762 4.13236L8.65275 2.40937C9.91001 1.18474 11.5989 0.5 13.3566 0.5C15.1142 0.5 16.8031 1.18476 18.0604 2.40939L18.0761 2.42505C19.3088 3.67474 20.0005 5.35635 20.0005 7.1092C20.0005 8.8571 19.3127 10.5342 18.0866 11.7827L16.4234 13.5575C16.0038 14.0052 15.3007 14.0281 14.8529 13.6085C14.4051 13.1888 14.3823 12.4857 14.8019 12.0379L16.4744 10.2533C16.4808 10.2464 16.4874 10.2396 16.4941 10.2328C17.318 9.3975 17.7783 8.27592 17.7783 7.1092C17.7783 5.94616 17.3209 4.82799 16.5019 3.99352C15.6618 3.1793 14.5332 2.72222 13.3566 2.72222C12.1774 2.72222 11.0465 3.18127 10.2059 3.99878Z"
            fill={color}
          />
        </svg>
      )}
    </i>
  );
}

export default LinkIcon;
